export default __webpack_public_path__ + "static/media/survey-footer.668c1ae4.png";